//import React from "react";
import { NavigateFunction, createBrowserRouter, RouterProvider, RouteObject, Navigate } from "react-router-dom";

import { default as DefLayout } from '../Layout/def_layout'
import CloudpanelLayout from "../Layout/cloudpanel_Layout";
import ToolspanelLayout from "../Layout/toolspanel_Layout";
import OperationspanelLayout from "../Layout/operationspanel_Layout"
//import TabMenu from "../tabMenu";

import { Def, Login, UserInformations} from "../../Containers/"

import { Pages as GlobalMenu_Pages, Router as GlobalMenu_Router, NavigationFunction as Global_Nav} from "./CloudPanel/globalMenu_Router"
import { Pages as SystemMenu_Pages, Router as SystemMenu_Router, NavigationFunction as System_Nav} from "./CloudPanel/systemMenu_Router"
import { Pages as ToolsMenu_Pages, Router as ToolsMenu_Router, NavigationFunction as Tools_Nav} from "./CloudPanel/toolsMenu_Router"
import { Pages as OperationsMenu_Pages, Router as OperationsMenu_Router, NavigationFunction as Operations_Nav} from "./OperationsPanel/operationsMenu_Router"
import { useUser } from "../../Services";

/* eslint-disable */
export enum RootPages {
  def="/",
  login="/login",
  userInformations="/userInformations"
}

export type Pages = RootPages | GlobalMenu_Pages | SystemMenu_Pages | ToolsMenu_Pages | OperationsMenu_Pages
export const Pages = {
  ...RootPages,
  ...GlobalMenu_Pages,
  ...SystemMenu_Pages,
  ...ToolsMenu_Pages,
  ...OperationsMenu_Pages,
}
/* eslint-enable */

function ProtectedRoute({ userToken, pageNavigation, children }: { userToken?: string, pageNavigation: GlobalMenu_Pages | OperationsMenu_Pages, children: React.ReactNode }) {
  if (!userToken) return <Navigate to={RootPages.login} state={{selected: pageNavigation}}  />;
  return <>{children}</>;
}

const rootRouter = (userToken?:string) => [
  { 
    path: "/",
    element: <DefLayout/>,
    //loader: rootLoader,  //#prefetch loader #See https://reactrouter.com/en/main/route/loader
    children: [
      {index:true, element: <Def />},
      // {path:RootPages.subPage, element: <SubPage />}
    ],
  },
  {
    path: RootPages.login,
    Component: Login
  },
  {
    path: RootPages.userInformations,
    Component: UserInformations
  },
  {
    Component: ToolspanelLayout,
    children: [ 
      ...ToolsMenu_Router
   ]
  },
  {
    // path: "/",
    element: (
      <ProtectedRoute userToken={userToken} pageNavigation={Pages.kpi}>
        <CloudpanelLayout/>
      </ProtectedRoute>
    ),
    children: [ 
      ...GlobalMenu_Router,
      ...SystemMenu_Router
    ]
  },
  {
    // path: "/",
    element: (
      <ProtectedRoute userToken={userToken} pageNavigation={Pages.op_operations}>
        <OperationspanelLayout/>
      </ProtectedRoute>
    ),
    children: [ 
      ...OperationsMenu_Router
    ]
  },
  {
    path:'*',
    element: (<Navigate to="/" />)
  }
] as RouteObject[]

export const NavigationFunction = (Navigator: NavigateFunction, navigation_page:Pages, navigation_sub?:Pages, replace:boolean=false, navArgs?:object) => {
  switch (navigation_page) {
    case RootPages.def:
      Navigator(RootPages.def, {replace:replace, state:navArgs})
    break
    case RootPages.login:
      Navigator(RootPages.login, {state: navArgs})
    break
    case RootPages.userInformations:
      Navigator(RootPages.userInformations)
    break
    default:
      if (Object.values(GlobalMenu_Pages).includes(navigation_page as any)) {
        Global_Nav(Navigator, navigation_page as GlobalMenu_Pages, navigation_sub as GlobalMenu_Pages, navArgs)
      }
      else if (Object.values(SystemMenu_Pages).includes(navigation_page as any)) {
        System_Nav(Navigator, navigation_page as SystemMenu_Pages, navigation_sub as SystemMenu_Pages, navArgs)
      }
      else if (Object.values(ToolsMenu_Pages).includes(navigation_page as any)) {
        Tools_Nav(Navigator, navigation_page as ToolsMenu_Pages, navigation_sub as ToolsMenu_Pages)
      }
      else if (Object.values(OperationsMenu_Pages).includes(navigation_page as any)) {
        Operations_Nav(Navigator, navigation_page as OperationsMenu_Pages)
      }
      else {
        console.error("Error page not found (404)???", navigation_page, navigation_sub)
        //alert("Error page not found (404)???")
      }
  }
}


export default function Root() {
  const {userToken} = useUser()
  return(
    <RouterProvider router={createBrowserRouter(rootRouter(userToken), {future: {
      v7_relativeSplatPath: true,
    }})} />
  )
}
